import animal from "./API/Animal";
import hospital from "./API/Hospital";
import species from "./API/Species";
import province from "./API/Province";
import district from "./API/District";
import subDistrict from "./API/SubDistrict";
import gender from "./API/Gender";
import contactType from "./API/ContactType";
import test from "./API/Test";
import order from "./API/Order";
import auth from "./API/Auth";
import creditType from "./API/CreditType";
import customerType from "./API/CustomerType";
import direction from "./API/Direction";
import urgencyHospitalType from "./API/UrgencyHospitalType";
import result from "./API/Result";
import status from "./API/Status";
import corporation from "./API/Corporation";
import rejectReason from "./API/RejectReason";
import cancelReason from "./API/CancelReason";
import sharedMethod from "./API/SharedMethod";
import account from "./API/Account";
import item from "./API/Item";
import permission from "./API/Permission";
import user from "./API/User";
import breed from "./API/Breed";
import qualityControl from "./API/QualityControl";

export default {
  animal,
  hospital,
  species,
  province,
  district,
  subDistrict,
  gender,
  contactType,
  test,
  order,
  auth,
  creditType,
  customerType,
  direction,
  urgencyHospitalType,
  result,
  status,
  corporation,
  rejectReason,
  cancelReason,
  sharedMethod,
  account,
  item,
  permission,
  user,
  breed,
  qualityControl,
};
